SectionInfo
	string	name
	int	totalFields
	int	requiredFields
	int	filledFields
	int	filledRequiredFields
	
Page editPage
	title = "Fahrzeug inserieren"
	needsAuth = true
	
	Good	good
	int	currentSectionIndex = 0
	Field[]	editableFields = []
	string[]	sections = []
	bool	showImportDropdown = false
	bool	sectionDirty = false
	ValidationState	validationState = {}
	User	seller

	createAndNavigateToNewGood
		good = app.createDefaultGood Draft
		System.log "createAndNavigateToNewGood", good
		await app.goods.add good
		app.navigateTo this, good.id

	show: string id
		if good == null or good.id != id
			good = await app.goods.fetchById(id)
		seller = good.seller == app.user.id ? app.user : await backend.users.fetchById good.seller
		html.setTitle title + app.titleSuffix
		currentSectionIndex = 0
		updateFields
		validationState.clear

	inline bool canEditField: Field field
		(app.user.userType == Admin or good.state != Review or field.editableWhileInReview)

	updateFields
		editableFields.clear
		sections.clear
		// Filter fields that should be shown for this kind of good
		app.fields.orderBy.editOrder
		for app.fields as field
			if field.showOnEditPage and field.showFor.contains(good.Typ) and canEditField(field)
				editableFields.add field
				if field.section and not sections.contains(field.section)
					sections.add field.section
				// Initialize field value if it doesn't exist
				if good[field.fieldName] == null
					good[field.fieldName] = ""

	getSectionInfo: string sectionName
		SectionInfo info = {name:sectionName}
		Field[] sectionFields = []
		for editableFields as field
			if field.section == sectionName
				sectionFields.add field
		info.totalFields = sectionFields.length
		int requiredCount = 0
		for sectionFields as field
			if field.required
				requiredCount++
		info.requiredFields = requiredCount
		info.filledFields = 0
		info.filledRequiredFields = 0
		return info

	draw
		if not good then return
		row padding:{top:20 bottom:20}, gap:28
			if not isMobile then drawSidebar
			drawMainContent

	drawSidebar
		div width:280, backgroundColor:#ffffff, borderRadius:20, padding:{top:24 bottom:24 left:24 right:24}
			boxShadow:{offset:{0,10}, blur:40, spread:0, color:#dfe4ef}
			display:flex, flexDirection:column, gap:20
			for sections as section
				drawSidebarSection section, i

	drawSidebarSection: string sectionName, int index
		let info = getSectionInfo(sectionName)
		let isActive = index == currentSectionIndex
		let isComplete = info.filledRequiredFields == info.requiredFields and info.requiredFields > 0
		let hasIncomplete = info.requiredFields > 0 and info.filledRequiredFields < info.requiredFields
		div display:flex, alignItems:center, gap:16, cursor:pointer
			backgroundColor:isActive ? lightColor : transparent
			padding:{top:12 bottom:12 left:12 right:12}, borderRadius:12
				onClick: await navigateToSection index
			// Circle icon
			div width:48, height:48, borderRadius:24, display:flex, alignItems:center, justifyContent:center
				fontSize:20, fontWeight:bold, color:#ffffff
				backgroundColor:isComplete ? green : (isActive ? primaryColor : #9aa2b1)
				div text:"{index + 1}"
			div text:sectionName, fontSize:16, fontWeight:bold, color:#2b3145, flex:1
			// div flex:1, display:flex, flexDirection:column, gap:4
			// 	div text:"{index + 1}. {sectionName}", fontSize:16, fontWeight:bold, color:#2b3145
			// 	if info.requiredFields > 0
			// 		div text:"{info.filledRequiredFields} / {info.requiredFields} Pflichtfelder"
			// 			fontSize:14, color:lightGray
			// 	else
			// 		div text:"Keine Pflichtfelder", fontSize:14, color:lightGray

	Field[] getCurrentSectionFields
		if sections.length == 0
			Field[] empty = []
			return empty
		let currentSection = sections[currentSectionIndex]
		Field[] result = []
		for editableFields as field
			if field.section == currentSection
				result.add field
		return result

	drawMainContent
		column flex:1, gap:24
			drawContentHeader
			let fields = getCurrentSectionFields
			string[] boxes = []
			for fields as field
				if not boxes.contains(field.box)
					boxes.add field.box
			
			for boxes as boxName
				Field[] boxFields = []
				for fields as field
					if field.box == boxName
						boxFields.add field
				drawBoxOfFields boxName, fields:boxFields
			
			if sections[currentSectionIndex] == "Preis & Standort"
				drawSellerDetails

			drawNavigation

	drawContentHeader
		if sections.length > 0
			let currentSection = sections[currentSectionIndex]
			let info = getSectionInfo(currentSection)
			div backgroundColor:#ffffff, borderRadius:20, padding:{top:24 bottom:24 left:24 right:24}
				boxShadow:{offset:{0,10}, blur:40, spread:0, color:#dfe4ef}
				display:flex, flexDirection:column, gap:16
				div display:flex, alignItems:center, justifyContent:spaceBetween
					div display:flex, flexDirection:column, gap:8
						div text:currentSection, fontSize:28, fontWeight:bold, color:#2b3145
						// if info.requiredFields
						// 	div text:info.filledRequiredFields == 0 ? "{info.requiredFields} Pflichtfelder" :
						// 			 info.filledRequiredFields == 1 ? "Es ist {info.filledRequiredFields} von {info.requiredFields} Pflichtfeldern ausgefüllt." :
						// 											  "Es sind {info.filledRequiredFields} von {info.requiredFields} Pflichtfeldern ausgefüllt." 
						// 		fontSize:14, color:lightGray

	drawBoxOfFields: string title, Field[] fields
		if fields.length == 0 then return
		div backgroundColor:#ffffff, borderRadius:20, padding:{top:32 bottom:32 left:32 right:32}
			boxShadow:{offset:{0,10}, blur:40, spread:0, color:#dfe4ef}
			if title
				div text:title, fontSize:18, fontWeight:bold, color:#2b3145
					borderBottom:{width:1px, style:solid, color:#2b3145}, paddingBottom:8
					margin:{bottom:24}
			// Two-column grid
			div display:flex, flexWrap:wrap, gap:24, alignItems:start
				for fields as field
					div width:.columns == 2 or isMobile ? "100%" : "calc(50% - 12px)"
						form.drawField field, new Reference(container:good, key:field.fieldName), validationState
							onInput: value => onFieldInput field, value

	drawSellerDetails
		div backgroundColor:#ffffff, borderRadius:20, padding:{top:32 bottom:32 left:32 right:32}
			boxShadow:{offset:{0,10}, blur:40, spread:0, color:#dfe4ef}
			div text:"Verkäufer", fontSize:18, fontWeight:bold, color:#2b3145
				borderBottom:{width:1px, style:solid, color:#2b3145}, paddingBottom:8
				margin:{bottom:24}
			div width:100%, display:flex, flexDirection:column, gap:16
				row gap:16
					form.text label:"Vorname", model:seller.firstName, width:50%, minTextLength:2, maxTextLength:50, required:true, validationState, onInput:sectionDirty=true
					form.text label:"Nachname", model:seller.lastName, width:50%, minTextLength:2, maxTextLength:50, required:true, validationState, onInput:sectionDirty=true
				form.text label:"Firmenname", model:seller.businessName, width:100%, minTextLength:2, maxTextLength:100, required:false, validationState, onInput:sectionDirty=true
				// Address Section
				form.text label:"Straße", model:seller.streetAddress, width:100%, minTextLength:5, maxTextLength:100, required:true, validationState, onInput:sectionDirty=true
				row gap:16
					form.text label:"Postleitzahl", model:seller.zipCode, width:30%, minTextLength:4, maxTextLength:10, required:true, validationState, onInput:sectionDirty=true
					form.text label:"Stadt", model:seller.city, width:80%, minTextLength:2, maxTextLength:50, required:true, validationState, onInput:sectionDirty=true
				form.text label:"Land", model:seller.country, width:100%, minTextLength:2, maxTextLength:50, required:true, validationState, onInput:sectionDirty=true
				form.text label:"Telefonnummer", model:seller.phoneNumber, width:100%, minTextLength:5, maxTextLength:20, required:true, validationState, onInput:sectionDirty=true

	onFieldInput: Field field, dynamic value
		good[field.fieldName] = value
		sectionDirty = true
		if good.state == Guest then good.state = Draft
		if field.fieldName == "Typ" and field.showFor.contains(value)
			updateFields
			if currentSectionIndex >= sections.length
				currentSectionIndex = sections.length > 0 ? sections.length - 1 : 0
			validationState.clear
			refresh
		if field.fieldName == "Motorleistung_in_PS" then good.Motorleistung_in_kW = math.round value * 0.735499; refresh; else
		if field.fieldName == "Motorleistung_in_kW" then good.Motorleistung_in_PS = math.round value / 0.735499; refresh;

	saveCurrentSection
		if not sectionDirty then return
		let fields = getCurrentSectionFields
		dynamic update = {}
		for fields as field
			update[field.fieldName] = good[field.fieldName]
		if good.state == GoodState.Guest then	good.state = GoodState.Draft
		if good.state == GoodState.Draft then	update["state"] = GoodState.Draft
		await app.goods.update good, update

		if sections[currentSectionIndex] == "Preis & Standort"
			let name = seller.firstName
			if seller.lastName then	name += " " + seller.lastName
			if seller.businessName then	name += ", " + seller.businessName
			await backend.users.update seller, {name, seller.firstName, seller.lastName, seller.businessName, seller.phoneNumber, seller.streetAddress, seller.zipCode, seller.city, seller.country}

		sectionDirty = false

	drawNavigation
		div display:flex, justifyContent:spaceBetween, alignItems:center
			app.button "Zurück", isDisabled: currentSectionIndex <= 0, onClick: await navigateToSection currentSectionIndex-1
			if currentSectionIndex < sections.length-1 then	app.button "Weiter", onClick: await navigateToSection currentSectionIndex+1
			else	app.button good.state == Review ? "Ok" : "Kostenlos inserieren", onClick: await finish

	navigateToSection: int sectionIndex, bool showErrrorsForEmptyFields = false
		if sectionIndex == currentSectionIndex	then return
		if validationState.checkForErrorsOrEmptyFields	then return
		await saveCurrentSection
		currentSectionIndex = sectionIndex

		validationState.clear
		validationState.showErrrorsForEmptyFields = showErrrorsForEmptyFields
		refresh
		html.scrollToTop

	remove
		app.goods.remove good
		app.navigateTo homePage
	
	finish
		if validationState.checkForErrorsOrEmptyFields then return
		await saveCurrentSection

		// Check that all required fields for all sections are filled
		for editableFields
			if .required and object.isUndefinedOrEmptyString(good[.fieldName])
				navigateToSection sections.indexOf(.section), showErrrorsForEmptyFields:true
				return
		try
			if good.state != Review
				await backend.post "/api/ready-for-review", {goodId:good.id}
				good.state = Review
			await app.navigateTo auctionPage, good.id
			refresh
		catch as error
			print type:Error "Error setting ready for review", error
			refresh

		
			

